import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.715 13.278c-.2-.2-.45-.29-.71-.29s-.51.1-.71.29l-6 6a1 1 0 0 0 0 1.42l6 6a.996.996 0 1 0 1.41-1.41l-4.29-4.29h14.59c2.14 0 4.15-.83 5.66-2.34a7.95 7.95 0 0 0 2.34-5.66c0-2.14-.83-4.15-2.34-5.66a7.95 7.95 0 0 0-5.66-2.34h-11c-.55 0-1 .45-1 1s.45 1 1 1h11c1.6 0 3.11.62 4.24 1.76a5.97 5.97 0 0 1 1.76 4.24c0 1.6-.62 3.11-1.76 4.24a5.97 5.97 0 0 1-4.24 1.76H7.415l4.29-4.29a.996.996 0 0 0 0-1.41z"
    />
  </svg>
);
const SvgIconReplyClockwise = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconReplyClockwise);
export default Memo;
